/*
 * complementary-color-match.js
 * "Abbinalo con:" coordinato al colore della variante con cui è caricata la
 * pagina prodotto. Lavora sulle card standard del tema (snippet product-item):
 * cambia foto, foto hover e link verso la variante dello stesso colore.
 * Se la card non ha quel colore resta com'è.
 *
 * Le card arrivano in ritardo e possono essere ridisegnate dopo di noi (fetch
 * di Stiletto, cambio variante, app delle miniature). Per questo non si segna
 * una card come "fatta": a ogni modifica della pagina si ricontrolla e si
 * corregge solo ciò che non corrisponde. Niente requestAnimationFrame, che si
 * ferma nelle schede in background.
 */
(function () {
  'use strict';
  if (window.__complementaryColorMatch) return;
  window.__complementaryColorMatch = true;

  function fileOf(url) {
    return String(url || '').split('?')[0].split('/').pop();
  }

  function readMap(script) {
    if (script.__colorMatchMap !== undefined) return script.__colorMatchMap;
    var map = null;
    try { map = JSON.parse(script.textContent); } catch (e) { map = null; }
    script.__colorMatchMap = map;
    return map;
  }

  // Il wrapper .image usa la dissolvenza del tema (animation--lazy-load + .loaded):
  // la si riattiva così la foto nuova entra come le altre invece di lasciare un vuoto.
  function setImage(img, src, srcset) {
    if (!img || !src) return;
    var wrapper = img.closest('.animation--lazy-load');
    if (wrapper) {
      wrapper.classList.remove('loaded');
      img.addEventListener('load', function () { wrapper.classList.add('loaded'); }, { once: true });
    }
    img.setAttribute('src', src);
    if (srcset) img.setAttribute('srcset', srcset);
    else img.removeAttribute('srcset');
    if (wrapper && img.complete && img.naturalWidth > 0) wrapper.classList.add('loaded');
  }

  // Colore uguale prima; se la card non ce l'ha, il primo dei colori simili (metafield shop custom.colori_simili, curato da EQ Boutique).
  function syncCard(script, colorKey, similar) {
    var map = readMap(script);
    if (!map) return;
    var match = map[colorKey];
    for (var k = 0; !match && k < similar.length; k++) match = map[similar[k]];
    if (!match) return;

    var slide = script.closest('[data-slide]') || script.parentElement;
    var card = slide && slide.querySelector('.product-item');
    if (!card) return;

    var main = card.querySelector('.product-item__image--one img');
    if (main && fileOf(main.getAttribute('src')) !== fileOf(match.src)) {
      // Se qualcosa continua a riscrivere la card, dopo 5 correzioni ci fermiamo.
      script.__colorMatchFixes = (script.__colorMatchFixes || 0) + 1;
      if (script.__colorMatchFixes > 5) return;
      setImage(main, match.src, match.srcset);
      var media = card.querySelector('.product-item__media');
      if (match.src2) {
        setImage(card.querySelector('.product-item__image--two img'), match.src2, match.srcset2);
      } else if (media) {
        media.classList.remove('product-item__media--multiple-images');
      }
    }

    var links = card.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      try {
        var url = new URL(href, window.location.origin);
        if (url.searchParams.get('variant') === String(match.id)) continue;
        url.searchParams.set('variant', match.id);
        links[i].setAttribute('href', url.pathname + url.search + url.hash);
      } catch (e) { /* href non valido: lo lasciamo com'è */ }
    }
  }

  function applyAll() {
    var blocks = document.querySelectorAll('[data-color-match]');
    for (var b = 0; b < blocks.length; b++) {
      var colorKey = blocks[b].getAttribute('data-color-match');
      if (!colorKey) continue;
      var similar = (blocks[b].getAttribute('data-color-similar') || '').split(',').filter(Boolean);
      var scripts = blocks[b].querySelectorAll('[data-color-match-variants]');
      for (var s = 0; s < scripts.length; s++) syncCard(scripts[s], colorKey, similar);
    }
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      applyAll();
    }, 60);
  }

  function start() {
    applyAll();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', schedule);
    window.addEventListener('pageshow', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
